import KunLoading74 from './src/index'

KunLoading74.install = function (Vue) {
	Vue.component(KunLoading74.name, KunLoading74);
}

export default KunLoading74;
